import React from 'react';
import moment from 'moment';
import { Stars } from '@prosolve/common-components-ui'

import { BiSolidQuoteAltLeft } from 'react-icons/bi';

export default ({
  id,
  stars,
  createdDate,
  questionsAndAnswers = [],
  focusedQuestion,
  isFirst
}) => {
  const formatDate = () => {
    const mmmmDD = moment(createdDate).format('MMMM DD');
    const year = moment(createdDate).format('YYYY');

    return `${mmmmDD}, ${year}`;
  }

  const questionAnswerOnly = Boolean(focusedQuestion);
 
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      marginTop: isFirst ? '0px' : '20px',
      // alignItems: 'center'
    }}>
      {
        !questionAnswerOnly &&
        <>
        <Stars stars={stars} />
        <div style={{
          marginTop: '0px',
          color: '#808080',
          fontSize: '13px'
        }}>
          {formatDate()}
        </div>
        </>
      }
      <div style={{
        marginTop: '10px'
      }}>
        {
          questionsAndAnswers.map(({ question, answer }, index) => {
            if (questionAnswerOnly && question !== focusedQuestion) {
              return <React.Fragment key={`q-${id}-question-${question}`}></React.Fragment>
            }
            else {
              return (
                <div key={`q-${id}-question-${question}`}>
                  {
                    !questionAnswerOnly &&
                    <div style={{
                      marginTop: '10px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#565656',
                      marginBottom: '2px',
                      textAlign: 'center'
                    }}>
                      {question}
                    </div>
                  }
                  <div style={{
                    fontSize: '16px',
                    color: '#565656',
                    backgroundColor: '#f8f8f8',
                    padding: '20px',
                    position: 'relative',
                    borderRadius: '5px'
                    // textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '28px',
                      color: '#a5a5a5',
                      position: 'absolute',
                      top: '17px'
                    }}>
                      <BiSolidQuoteAltLeft />
                    </div>
                    {/* <span style={{ marginRight: '1px' }}>"</span> */}
                    <span style={{ marginLeft: '50px', lineHeight: '25px' }}>{answer}</span>
                    {/* <span style={{ marginLeft: '1px' }}>"</span> */}
                  </div>
                </div>
              )
            }
          })
        }
      </div>
      {/* <div style={{
        color: '#0280c6',
        fontSize: '13px',
        fontWeight: 'bold',
        cursor: 'pointer'
      }}>
        View Full Review
      </div>
      <div style={{
        width: '80%',
        height: '20px',
        borderBottom:  '1px solid #dedede'
      }}>
        &nbsp;
      </div> */}
    </div>
  )
}
